.header-container {
    display: flex;
    border-radius: 8px 0 0 0;
    min-width: 650px;
}

.header-content {
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    border-radius: 8px 0 0 0;
}

.header-blue {
    background-color: var(--info-bg);
}

.header-purple {
    background-color: var(--ai-purple-pink-xlt);
}

.header-text {
    font-size: 25px;
    font-weight: 500;
    color: var(--grey-dk);
    font-family: 'Doyle';
    line-height: 28px;
}
